import { render, staticRenderFns } from "./RelatedAccountsComponent.vue?vue&type=template&id=5e5575e2&scoped=true"
import script from "./RelatedAccountsComponent.vue?vue&type=script&lang=js"
export * from "./RelatedAccountsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5575e2",
  null
  
)

export default component.exports